// @ts-check
import Popup from "Components/Common/popup";
import 'Styles/commonComponents/settings/actionSetting.scss';
import IconsContainer from "Utils/IconsContainer";
import { observer } from "mobx-react";
import React from "react";

/**
 * @param {{
 * id?: string | undefined,
 * title?: string,
 * helperText?: string,
 * disabled?: boolean,
 * value: string,
 * onClick: () => void
 * }} props 
 * @returns {React.JSX.Element}
 */
const ActionSetting = (props) => {
    return (
        <div className='setting-container action-setting'>

            {
                props.title ?
                    <div className='setting-title action-setting-title'>
                        {props.title}
                        {props.helperText ?
                            <Popup
                                popupText={props.helperText}
                                className='fast-info-popup'>
                                {IconsContainer.Get('ci-info')}
                            </Popup>
                            : ''}
                    </div>
                    : ''
            }

            <div>
                <button
                    id={props.id}
                    onClick={(e) => props.onClick()}
                    className={props.disabled ? 'disabled' : ''}>
                    {props.value}
                </button>
            </div>

        </div>
    )
}

export default observer(ActionSetting);